import {
  atom,
  useRecoilState,
  RecoilState
} from 'recoil';

import * as _ht from './_ht';

export const grtAtom = (
  key: _ht.s, 
  itl: _ht.a
): RecoilState<_ht.a> => {
  return atom({
    key: key,
    default: itl,
  })
};

export const grtStt = (
  atom: RecoilState<_ht.a>
) => {
  const _ls = useRecoilState(atom);
  return {
    clr: () => _ls[1]({}),
    crt: _ls[0],
    set: (pDz: { [_key: string]: _ht.a}) => _ls[1]({ ..._ls[0], ...pDz })
  }
};
